import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SUPPORT_EMAIL } from '@utils/constants';

import EmailForm from './EmailForm';
import ForcedLogoutMessage from './ForcedLogoutMessage';
import LoginLinkSent from './LoginLinkSent';
import PasswordForm from './PasswordForm';

export const FormRenderMap = {
  email: 'EmailForm',
  password_form: 'PasswordForm',
  success_login_link: 'LoginLinkSent',
};
type FormRenderMapValues = (typeof FormRenderMap)[keyof typeof FormRenderMap];

const NewSessionPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState<string>(searchParams.get('email'));
  const [currentForm, setCurrentForm] = useState<FormRenderMapValues>(FormRenderMap['email']);
  const [returningUrl, setReturningUrl] = useState<string>(searchParams.get('returning_url'));
  const forcedLogout = searchParams.get('fl');

  return (
    <div id="login-page">
      {forcedLogout && <ForcedLogoutMessage forcedLogout={forcedLogout} />}
      <div className="mx-16 sm:mx-auto sm:w-[420px]">
        {currentForm === FormRenderMap['email'] ? (
          <EmailForm
            email={email}
            setEmail={setEmail}
            returningUrl={returningUrl}
            setReturningUrl={setReturningUrl}
            setCurrentForm={setCurrentForm}
          />
        ) : currentForm === FormRenderMap['password_form'] ? (
          <PasswordForm
            email={email}
            returningUrl={returningUrl}
            setEmail={setEmail}
            setCurrentForm={setCurrentForm}
          />
        ) : currentForm === FormRenderMap['success_login_link'] ? (
          <LoginLinkSent email={email} />
        ) : (
          <div>
            Sorry, we hit an unknown error. Please reload the page or email{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[#F32A52]">
              {SUPPORT_EMAIL}
            </a>
            .
          </div>
        )}
      </div>
    </div>
  );
};

export default NewSessionPage;
